import type { PeopleResult } from '../../outreachTypes';

/** The four steps of a pitch (design outreach-v2 t1): sent, opened, listened 30 s+, replied or added. */
export const PITCH_STEPS = 4;

export type PitchStepTone = 'pos' | 'vio' | 'muted';

export interface PitchProgress {
  /** How many of the four steps the pitch reached (0 for a planned pitch). */
  reached: number;
  tone: PitchStepTone;
}

/**
 * The steps that a result reached. The API sends the best event of a pitch, and each step means the
 * steps before it (a listen means an open), so the track needs no other data.
 */
export function pitchProgressOf(result: PeopleResult): PitchProgress {
  switch (result) {
    case 'added':
      return { reached: 4, tone: 'pos' };
    case 'replied':
      return { reached: 4, tone: 'pos' };
    case 'listened':
      return { reached: 3, tone: 'vio' };
    case 'opened':
      return { reached: 2, tone: 'vio' };
    case 'scheduled':
      return { reached: 0, tone: 'muted' };
    case 'sent':
    case 'followUpOn':
    default:
      return { reached: 1, tone: 'muted' };
  }
}
